import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NouisliderModule } from 'ng2-nouislider';
import { JwBootstrapSwitchNg2Module } from 'jw-bootstrap-switch-ng2';
import { RouterModule } from '@angular/router';

import { BasicelementsComponent } from './basicelements/basicelements.component';
import { NavigationComponent } from './navigation/navigation.component';
import { TypographyComponent } from './typography/typography.component';
import { NucleoiconsComponent } from './nucleoicons/nucleoicons.component';
import { ComponentsComponent } from './components.component';
import { NotificationComponent } from './notification/notification.component';
import { NgbdModalComponent, NgbdModalContent_olde } from './modal/modal.component';
import { ActualiterComponent } from '../page/actualiter/actualiter.component';
import { InfrastructureComponent } from '../page/infrastructure/infrastructure.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PopupModule } from 'ng2-opd-popup';
import { LiensUtilComponent } from './liens-util/liens-util.component';
import { MedecinCmsComponent } from '../examples/index/medecin-cms/medecin-cms.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        NgbModule,
        NouisliderModule,
        RouterModule,
        JwBootstrapSwitchNg2Module,
        PdfViewerModule,
        PopupModule.forRoot(),
    ],
    declarations: [
        ComponentsComponent,
        BasicelementsComponent,
        NavigationComponent,
        TypographyComponent,
        NucleoiconsComponent,
        NotificationComponent,
         NgbdModalComponent,
         NgbdModalContent_olde,
        ActualiterComponent,
        InfrastructureComponent,
        MedecinCmsComponent,
        LiensUtilComponent
    ],
    entryComponents: [NgbdModalContent_olde],
    exports:[ ComponentsComponent ]
})
export class ComponentsModule { }
